import { render } from "./Footer.vue?vue&type=template&id=ce94623a"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=ce94623a&lang=scss"
script.render = render

export default script